import { ReportApplicationNextStep } from '@brokerportal/modules/application/reports/shared/next-step.enum';
import { CreditStatus, StepName } from '../enums';
import { isHeslp } from './external-program';

export const getCurrentStatusDescription = (dataItem: any): string => {
    const castWorkflowStepName = StepName[<keyof typeof StepName>dataItem.workflowStep];
    const castNextStep = ReportApplicationNextStep[<keyof typeof ReportApplicationNextStep>dataItem.nextStep];
    const isSettlementsV2App = dataItem.actionRequiredCondition && dataItem.actionRequiredCondition !== 'Undefined';
    const isRenewableInterestFree = dataItem.product && dataItem.product.toLowerCase() === 'renewableinterestfree';
    const isIdentityStatusPass = dataItem.userIdentityCheckStatus === 'Pass';

    // For HESLP the loan contract is only generated after full approval (creditStatus = Approved),
    // so a HESLP application at conditional approval is never legitimately "awaiting contract signing".
    // Suppress the Settlements V2 override in that case and fall back to the Venus-computed status.
    // ZIPP / WABS (RenewableInterestFree but not HESLP) are unaffected.
    const isHeslpAtConditionalApproval =
        isHeslp(dataItem) && dataItem.creditStatus === CreditStatus[CreditStatus.ConditionallyApproved];

    const remindableWorkflowSteps = [
        StepName.AccountCreation,
        StepName.AcceptTerms,
        StepName.DirectDebitDetails,
        StepName.PreContractualDocumentGeneration,
        StepName.FinalLoanContractSigningAgain,
        StepName.FinalLoanContract
    ];

    if (castNextStep !== ReportApplicationNextStep.VerifyIdentity) {
        remindableWorkflowSteps.push(StepName.ConditionallyApprovedApplicationReceived);
    }

    if (
        isRenewableInterestFree &&
        isSettlementsV2App &&
        remindableWorkflowSteps.includes(castWorkflowStepName) &&
        !isHeslpAtConditionalApproval
    ) {
        return 'Awaiting contract signing' + (isIdentityStatusPass ? '' : ' and ID verification');
    }

    return dataItem.currentStatusDescription;
};
